import { WEB_TYPES, WEB_TYPES_KEYS } from '../Core/Redux/SettingsRedux'
import { createSelector } from 'reselect'
import { selectAppData } from './common'

const selectSettings = (state) => selectAppData(state).settings

const selectWebSettings = (state) => selectSettings(state).webSettings
const selectWebType = (state) => selectSettings(state).webType

export const selectActiveSettings = createSelector(selectWebSettings, selectWebType, (webSettings, webType) => {
  return webSettings[WEB_TYPES_KEYS[webType]] ? webSettings[WEB_TYPES_KEYS[webType]] : {}
})

export const showCebiaSelector = createSelector([selectWebType], (webType) => [WEB_TYPES.SRO].includes(webType))
